import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-LampWithCircle",
  "use": "svg-icon-LampWithCircle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-LampWithCircle\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18h5v1.5a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5V18z\" fill=\"#fff\" /><path d=\"M15 16.5c0-2.844 3-5.1 3-7.9C18 5.507 15.537 3 12.5 3S7 5.507 7 8.6c0 2.8 3 5.144 3 7.9h5z\" fill=\"#fff\" /><rect x=\"15.5\" y=\"3.5\" width=\"5\" height=\"5\" rx=\"2.5\" fill=\"#FFF1BA\" stroke=\"#FC0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol